/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-07-03 16:46:24
 */

import * as request from '@/utils/request'

export default {
  /**
   * getTradeRechargeList
   * @description 充值流水
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getAdminTradeRechargeList(data) {
    return request.post('/admin_trade/rechargeList', data)
  },
  /**
   * getTradeWithDrawList
   * @description 交易流水
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getAdminTradeWithdrawList(data) {
    return request.post('/admin_trade/withdrawList', data)
  },
  /**
   * getTradeTaxList
   * @description 交易订单
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getAdminTradeTaxList(data) {
    return request.post('/admin_trade/taxList', data)
  },
}